.o7suo70 {
  display: flex;
  margin-top: 32px;
  gap: 16px;
  justify-content: end;
}